import { ENCRYPT_GUID, ENCRYPT_DNF_GUID } from '../../store/schema/rms/EncryptionGUID';
import type { InfoBarMessageId } from '../protectionInfobarMessageId';
import { isConsumer } from 'owa-session-store';

export default function getEncryptionInfoBarMessageId(
    templateId: string | undefined
): InfoBarMessageId {
    if (isConsumer()) {
        switch (templateId) {
            case ENCRYPT_GUID:
                return 'encryption';
            case ENCRYPT_DNF_GUID:
                return 'encryptionDoNotForward';
            default:
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS2322 (18,17): Type 'null' is not assignable to type 'InfoBarMessageId'.
                // @ts-expect-error
                return null;
        }
    } else {
        return 'irmInfoBar';
    }
}
